import React from "react";
import Offer from "./offer";
import { convertBuyerTags, convertOfferTags } from "./utils";
// import { mock, buyerType } from "../mock";
import "./index.css";
export default function SmartUiOffer(props) {
  var _props$data = props.data,
    data = _props$data === void 0 ? {} : _props$data,
    _props$buyerTags = props.buyerTags,
    buyerTags = _props$buyerTags === void 0 ? [] : _props$buyerTags,
    _props$wwClick = props.wwClick,
    wwClick = _props$wwClick === void 0 ? function () {} : _props$wwClick;
  var _data$offerTags = data.offerTags,
    offerTags = _data$offerTags === void 0 ? [] : _data$offerTags;
  var buyerIdentity = convertBuyerTags(buyerTags);
  var offerUIInfo = convertOfferTags(offerTags);
  try {
    return /*#__PURE__*/React.createElement(Offer, {
      buyerIdentity: buyerIdentity,
      offerUIInfo: offerUIInfo,
      data: data,
      wwClick: wwClick
    });
  } catch (e) {
    console.log(e);
    return null;
  }
}